import React, {useEffect, useState} from "react";
import {Button, DescriptionListItemActions, Icon, useNotifications} from "peggirkit";
import {CheckIcon, ClipboardDocumentIcon} from "@heroicons/react/16/solid";
import {FormattedMessage, useIntl} from "react-intl";
import {useTooltip} from "@widgets/tooltip/TooltipProvider";
import {notifySuccess} from "@/utils/NotifyUtils";

type Props = {
    textToCopy: string | undefined | null,
};

const DescriptionListCopyButton = ({textToCopy}: Props) => {
    const intl = useIntl();
    const [copied, setCopied] = useState(false);
    const {applyTooltip} = useTooltip();
    const {notify} = useNotifications();

    useEffect(() => {
        if (!copied)
            return;

        notifySuccess(intl.formatMessage({id: "copiedSuccessfully"}), notify);
        const t = setTimeout(() => setCopied(false), 2000);
        return () => clearTimeout(t);
    }, [copied, intl, notify]);

    return (
        <DescriptionListItemActions>
            <Button
                variant={"link"}
                iconBefore={<Icon icon={copied ? CheckIcon : ClipboardDocumentIcon}/>}
                iconOnly={true}
                disabled={textToCopy === undefined || textToCopy === null}
                props={{
                    ...applyTooltip(intl.formatMessage(({id: copied ? "copied" : "copy"}))),
                    "aria-label": intl.formatMessage(({id: copied ? "copied" : "copy"})),
                }}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: e => {
                            e.preventDefault();
                            if (!textToCopy)
                                return;

                            navigator
                                .clipboard
                                .writeText(textToCopy)
                                .then(() => setCopied(true));
                        },
                    },
                }}
            >
                <FormattedMessage id={"copy"}/>
            </Button>
        </DescriptionListItemActions>
    );
};

export default DescriptionListCopyButton;